module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/img (78).1b881ff3.jpg";